import React from "react";
import { connect } from "react-redux";
import './ActivityLogSubComponent.css';

class ActivityLogSubComponent extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			
		}
    }


    componentDidMount(){}
	componentWillUnmount(){
    }

  
    render(){
    console.log('Inside render');
    return(
            <div>
			<div class="actylog">
                    <ul>
                        <li><p class="logdate">Today <span class="logtime">12:17 PM</span></p>
                            <p>Bill Pay to <a href="#">Mahesh Kumar</a> and <a href="#">Ramesh Swmay</a> from Laptop (Dell) Window 10 browser - Chrome,  India (Delhi)  - IP 157.34.112.194</p>
                        </li>
                        
                        <li><p class="logdate">24-11-2021 <span class="logtime">10:23 AM</span></p>
                            <p>Login to dashboard from Mobile (Oppo Reno 2 Z) Android browser - Firefox,  India (MP)  - IP 157.34.112.194 </p>
                        </li>
                        
                        <li class="add"><p class="logdate">21-11-2021 <span class="logtime">08:45 AM</span></p>
                            <p>Corporate Admin Load money to your account from Mobile (Oppo Reno 2 Z) Android browser - Firefox,  India (MP)  - IP 157.34.112.194 </p>
                        </li>
                        
                        <li class="delete"><p class="logdate">14-11-2021 <span class="logtime">13:56 PM</span></p>
                            <p>Bill due pending <a href="#">Rajesh Gupta</a> from Mobile Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text of the printing and <a href="#">typesetting</a> industry. Lorem Ipsum has been the industry's standard dummy text</p>
                        </li>
                        
                        <li><p class="logdate">12-11-2021 <span class="logtime">13:56 PM</span></p>
                            <p>Bill Pay to <a href="#">Mahesh Kumar</a> and <a href="#">Ramesh Swmay</a> from Laptop (Dell) Window 10 browser - Chrome,  India (Delhi)  - IP 157.34.112.194</p>
                        </li>
                        
                        <li><p class="logdate">28-10-2021 <span class="logtime">10:23 AM</span></p>
                            <p>Login to dashboard from Mobile (Oppo Reno 2 Z) Android browser - Firefox,  India (MP)  - IP 157.34.112.194 </p>
                        </li>
                        
                        <li class="add"><p class="logdate">21-10-2021 <span class="logtime">08:45 AM</span></p>
                            <p>Corporate Admin Load money to your account from Mobile (Oppo Reno 2 Z) Android browser - Firefox, India (MP) - IP 157.34.112.194 </p>
                        </li>
                        
                        <li class="delete"><p class="logdate">14-10-2021 <span class="logtime">13:56 PM</span></p>
                            <p>Bill due pending <a href="#">Rajesh Gupta</a> from Mobile Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text of the printing and <a href="#">typesetting</a> industry. Lorem Ipsum has been the industry's standard dummy text</p>
                        </li>
                    </ul>
            </div>

            <div class="pager">
            <p>Showing 1 to 10 of 270 entries</p>					
            <ul class="pagination pagination-sm">
                <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                <li class="page-item active"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item"><a class="page-link" href="#">4</a></li>
                <li class="page-item"><a class="page-link" href="#">Next</a></li>
            </ul>						
            </div>	
            </div>
        );
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(ActivityLogSubComponent);
